import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPinLocation = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: "2.5em",
	height: "2.5em",
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M29 17.1429C29 22.7429 20 32 20 32C20 32 11 22.7429 11 17.1429C11 11.3143 15.6125 8 20 8C24.3875 8 29 11.3143 29 17.1429Z",
		stroke: "currentColor",
		strokeWidth: 2,
		strokeMiterlimit: 10,
		strokeLinecap: "square"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M20.1429 20.5714C22.0364 20.5714 23.5714 19.0364 23.5714 17.1429C23.5714 15.2493 22.0364 13.7143 20.1429 13.7143C18.2493 13.7143 16.7143 15.2493 16.7143 17.1429C16.7143 19.0364 18.2493 20.5714 20.1429 20.5714Z",
		stroke: "currentColor",
		strokeWidth: 2,
		strokeMiterlimit: 10,
		strokeLinecap: "square"
	})]
});
const ForwardRef = forwardRef(SvgPinLocation);
export default ForwardRef;
